import { Dialog, DialogContent } from "@/components/dialog"

/**
 * Base container component for token selection dialogs.
 * Accepts child components that are rendered in order.
 * All business logic and state management should happen in parent components.
 */
export const TokenStoreDialog: React.FC<{
  title: string
  minHeight?: number
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}> = ({ isOpen, onClose, children, minHeight: minHeight = 540, title }) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(value: boolean) => {
        if (!value) {
          onClose()
        }
      }}
    >
      <DialogContent title={title} className="token-store-dialog relative" style={{ minHeight: `${minHeight}px` }}>
        {children}
      </DialogContent>
    </Dialog>
  )
}
